import $ from 'jquery';
import Handlebars from 'handlebars';
// https://github.com/marioizquierdo/jquery.serializeJSON
require('jquery-serializejson');
require('parsleyjs');
require('jquery-datepicker');
// https://github.com/helpers/handlebars-helpers
// http://assemble.io/helpers/helpers-comparison.html
const helpers = require('handlebars-helpers')();
// https://lodash.com/
const _ = require('lodash');
const ScrollMagic = require('scrollmagic');


// Used for valid ajax call
const data = {
	CSRF: $('input[name="CSRF"]').val(),
};


// Boiler Data
let boilerData;


// Counter
let counter;


// Selected Boilers array
let selectedBoilers = [];


// UK bank holidays
let bankHolidays = [];


// Elements
const $el = {
	holder: $('.js-commissioning-form-holder'),
	boilerHolder: $('#boiler-holder'),
	boilerElement: $('#boiler-element'),
	boilerDetailsElement: $('#boiler-details'),
	duplicateFieldsHolder: $('#duplicate-fields-holder'),
	duplicateFields: $('#duplicate-fields'),
	commissioningHolder: $('#commissioning-holder'),
	commissioningElement: $('#commissioning-element'),
	boiler: $('.js-boiler'),
	boilerDetails: $('.js-boiler-deltails'),
	boilerSelector: $('.js-boiler-selector'),
	addBoiler: $('.js-add-boiler'),
	finishedBoiler: $('.js-finished-boiler'),
	removeBoiler: $('.js-remove-boiler'),
	form: $('#commissioningForm'),
	submit: $('.js-submit'),
	loader: $('.c-loader'),
	step1: $('.js-step-1'),
	step2: $('.js-step-2'),
	datePicker: $('.js-datepicker'),
	datePickerComplex: $('.js-datepicker-complex'),
	inductionSelect: $('.js-induction'),
	inductionTime: $('.js-induction-time'),
	inductionCost: $('.js-induction-cost'),
	inductionTimeInput: $('.js-induction-time-input'),
	inductionCostInput: $('.js-induction-cost-input'),
	inductionAdditional: $('.js-induction-additional'),
	conditionalRadio: $('.js-conditional-radio'),
	conditionalField: $('.js-conditional-field'),
	successMessage: $('.js-success-message'),
	errorMessage: $('.js-error-message'),
};


// Retrieve the template data from the HTML (jQuery is used here).
const boilerTemplate = $el.boilerElement.html();
const boilerDetailsTemplate = $el.boilerDetailsElement.html();
const duplicateTemplate = $el.duplicateFields.html();
const commissioningTemplate = $el.commissioningElement.html();


// Handlebar helper to convert to lowecarse and add underscore
Handlebars.registerHelper('label', function(input) {
	const output = input.toLowerCase();
	return output.replace(' ', '_');
});


// Module events
export default function init() {

	loadModels();
	initialState();
	bindEvents();
	//Check if we need this
	//$el.form.parsley();
	loadBankHolidays();
	datePicker();

	// Stop validation on hidden fields
	window.Parsley.on('field:validated', function(fieldInstance) {
		if (fieldInstance.$element.is(':hidden')) {
			// console.log('fieldInstance.$element', fieldInstance.$element);
			// hide the message wrapper
			// fieldInstance._ui.$errorsWrapper.css('display', 'none');
			fieldInstance.$element.parent().removeClass('parsley-error');
			// set validation result to true
			fieldInstance.validationResult = true;
			return true;
		}
	});
}


// Bind events
function bindEvents() {
	$el.addBoiler.on('click', addBoiler);
	$el.finishedBoiler.on('click', finishedBoilers);
	$el.boilerHolder.on('change', '.js-boiler-selector', addBoilerDetails);
	$el.boilerHolder.on('click', '.js-remove-boiler', removeBoiler);
	$el.submit.on('click', submitForm);
	$el.form.on('click', '.js-conditional-radio input', showField);
	$el.inductionSelect.on('change', inductionCost);
}


// Ajax call to load Boiler data from Craft API
function loadModels() {
	$.ajax({
		type: 'get',
		url: '/api/boilers.json',
		dataType: 'json',
		cache: false,
		data: data,
	}).done(function (response) {
		// assign data from ajax call
		boilerData = response;
		// once we have data show form and hide loader
		$el.form.show();
		$el.loader.hide();
	}).fail(function (error) {
		console.log(error);
	});
}


// set initial states on elements
function initialState() {

	// Hide the form until weve loaded the data
	$el.form.hide();
	
	// Hide finished boiler button, we havent added any yet
	$el.finishedBoiler.hide();
	
	// Hide step 2 until we've added boilers
	$el.step2.hide();

	// Hide the messages
	$el.successMessage.hide();
	$el.errorMessage.hide();

	// Hide additional induction costs
	$el.inductionAdditional.hide();
}


// Add a boiler
function addBoiler() {

	// increase the counter based on number of boilers added
	counter = $('.js-boiler').size() + 1;

	// setup a counter to count how many boilers have been added
	const count = {
		count: [{ count: counter }]
	};

	// Merge Counter and boiler data
	boilerData = _.merge(boilerData, count);

	// Apply data to handlebars template
	const boilerTemplateScript = Handlebars.compile(boilerTemplate);
	const html = boilerTemplateScript(boilerData);

	// Append to holding html
	$el.boilerHolder.append(html);

	// we can only add up-to 10 boilers 
	if (_.get(boilerData, 'count.0.count') > 10) {
		$el.addBoiler.hide();
	}

	// Update button text
	if (_.get(boilerData, 'count.0.count') > 0) {
		$el.addBoiler.text('Add another boiler');
		$el.finishedBoiler.show();
	}

	return false;
	
}


// Add Boiler details from selected boiler
function addBoilerDetails() {

	// remove chosen boiler details
	$(this).closest('.js-boiler').find('.js-boiler-details').remove();

	// Get select boiler title
	const selectedBoiler = $(this).val();

	// Get the current count of this boiler
	const currentCount = {
		count: [{ count: $(this).closest('.js-boiler').data('count') }]
	};

	// Filter data to return only selected boiler
	let selectedBoilerData = _.filter(boilerData.data, { title: selectedBoiler });

	// Merge in boiler count to filtered data
	selectedBoilerData = _.merge(selectedBoilerData, currentCount);
	
	// Apply new filtered data
	const boilerDetailsTemplateScript = Handlebars.compile(boilerDetailsTemplate);
	const html = boilerDetailsTemplateScript(selectedBoilerData);

	// Append new boiler details
	$(this).closest('.js-boiler').append(html);

	// init datepaicker on newly created elements
	datePicker(this);

	// Prevent default action
	//event.preventDefault();
	return false;

}


// Finished adding boilers
function finishedBoilers() {

	// holder for valid boiler fields
	let boilersValid;

	// // Run parsley validation on boiler fields
	const form = $el.boilerHolder;

	form.parsley().validate();

	// If Valid set here
	if (form.parsley().isValid()) {
		boilersValid = true;
	}
	
	// Only run if valid
	if (boilersValid) {

		// Hide the add boiler button
		$el.addBoiler.hide();

		// Run duplicates function
		duplicateBoilers();

		// Hide finished button
		$el.finishedBoiler.hide();

		// Hide remove boiler buttons
		$el.removeBoiler.hide();

		// disable boiler fields
		$el.boilerHolder.find('input, select').prop('disabled', true);

		// Show step 2
		$el.step2.show();

	}

	// Prevent default action
	//event.preventDefault();
	return false;

}

// We can only remove the last added boiler otherwise the count goes out of sync - Handlebars is already rendered
function removeBoiler() {

	// remove this boiler
	$(event.target).closest('.js-boiler').remove();

	// decrease the counter based on number of boilers added
	counter = $('.js-boiler').size();

	// setup a counter to count how many boilers have been added
	const count = {
		count: [{ count: counter }]
	};

	// Merge Counter and boiler data
	boilerData = _.merge(boilerData, count);

	return false;
}


// Check for dulplicate boilers to show more questions
function duplicateBoilers() {

	// Empty selected Boilers - incase we have updated the boilers
	selectedBoilers = [];

	// Add each selected boiler to array
	$('.js-boiler-details').each(function() {
		selectedBoilers.push($(this).data('boiler'));
	});


	// We need to add ALL the selected boilers to the Commissioning costs table
	const commissioningTemplateScript = Handlebars.compile(commissioningTemplate);
	const selectedHtml = commissioningTemplateScript(selectedBoilers);

	console.log(selectedBoilers);

	// Append to holding html
	$el.commissioningHolder.append(selectedHtml);


	// Get the first index of the requested boiler in the array
	const firstIndex = function(array, boiler) {
		return _.findIndex(array, function(_boiler) {
			return _boiler === boiler;
		});
	};

	// Get the last index of the requested boiler in the array
	const lastIndex = function(array, boiler) {
		return _.findLastIndex(array, function(_boiler) {
			return _boiler === boiler;
		});
	};

	// Compare first and last 
	const duplicateBoilersData = function() {
		return _.map(selectedBoilers, function(_boiler) {
			if (firstIndex(selectedBoilers, _boiler) !== lastIndex(selectedBoilers, _boiler)) {
				return _boiler;
			} 
			return false;
		});
	};

	// Narrow the duplicates array to unique entries
	selectedBoilers = _.uniq(duplicateBoilersData());

	// Add results to array
	selectedBoilers = _.toArray(selectedBoilers);

	// remove old data
	$el.duplicateFieldsHolder.empty();

	// Apply data to handlebars template
	const duplicateTemplateScript = Handlebars.compile(duplicateTemplate);
	const html = duplicateTemplateScript(selectedBoilers);

	// Append to holding html
	$el.duplicateFieldsHolder.append(html);

}


// Show hidden field if radio selected is Yes
function showField() {

	const conditionalField = $(this).closest('.js-conditional-radio').nextAll('.js-conditional-field');
	const formInput = $(this).closest('.js-conditional-radio').nextAll('.js-conditional-field').find('input, select, textarea');

	// Show content if the selected option matches
	if ($(this).hasClass('js-conditional-trigger')) {
		conditionalField.show();      
	} else {
		conditionalField.hide();  
	}

	// Add/remove required attribute so we dont validate hidden fields
	if (conditionalField.is(':visible')) {
		formInput.prop('required', true);
	} else {
		formInput.prop('required', false);
	}
}


// Datepicker
function datePicker(_this) {
	// stop normal text input 
	$(_this).closest('.js-boiler').find('.js-datepicker').prop('readonly', true);

	// Install Date (Needs jQuery UI Datepicker)
	$(_this).closest('.js-boiler').find('.js-datepicker').datepicker({
		dateFormat: 'd-M-y',
		changeYear: true,
		changeMonth: true,
		onSelect: function(date) {
           $(this).parsley().reset();
        }
	});
}

// Date picker with Weekends, bank holidays, and next 7 days disabled
function datePickerComplex() {

	// stop normal text input
	$el.datePickerComplex.prop('readonly', true);

	// Work out business days
	function AddWeekDays(weekDaysToAdd) {
		let daysToAdd = 0;
		const mydate = new Date();
		const day = mydate.getDay();
		weekDaysToAdd = weekDaysToAdd - (5 - day);
		if ((5 - day) < weekDaysToAdd || weekDaysToAdd === 1) {
			daysToAdd = (5 - day) + 2 + daysToAdd;
		} else { // (5-day) >= weekDaysToAdd
			daysToAdd = (5 - day) + daysToAdd;
		}
		while (weekDaysToAdd !== 0) {
			const week = weekDaysToAdd - 5;
			if (week > 0) {
				daysToAdd = 7 + daysToAdd;
				weekDaysToAdd = weekDaysToAdd - 5;
			} else { // week < 0
				daysToAdd = (5 + week) + daysToAdd;
				weekDaysToAdd = weekDaysToAdd - (5 + week);
			}
		}

		return daysToAdd;
	}

	// Check if it's a weekend
	function IsWeekend(date) {
		if (date.getDay() === 0 || date.getDay() === 6) {
			return true;
		}
		return false;
	}

	// Apply weekends and bank holidays as disabled dates
	function noWeekendsOrHolidays(date) {
		const string = $.datepicker.formatDate('yy-mm-dd', date);
		const isDisabled = (!IsWeekend(date)) && (bankHolidays.indexOf(string) === -1); // used to disable if its an holiday or weekend
		return [isDisabled];
	}

	// Set up min date that can be selected
	const dateMin = new Date();
	const weekDays = AddWeekDays(7);
	dateMin.setDate(dateMin.getDate() + weekDays);

	$el.datePickerComplex.datepicker({
		beforeShowDay: noWeekendsOrHolidays,
		minDate: dateMin,
		dateFormat: 'dd/mm/yy',
		firstDay: 1,
		changeFirstDay: false,
		yearRange: '0:+1',
		onSelect: function(date) {
           $(this).parsley().reset();
        }
	})
}


// Load UK bank holidays data from UK gov site
function loadBankHolidays() {
	$.ajax({
		type: 'get',
		url: 'https://www.gov.uk/bank-holidays.json',
		dataType: 'json',
		cache: false,
		data: data,
	}).done(function (response) {
		// Get England bank holidays from feed
		const listOfEvents = response['england-and-wales'].events;
		// Push holidays into array to use in datepicker
		bankHolidays = _.map(listOfEvents, 'date');
		// Initiate Datepicker	
		datePickerComplex();
	}).fail(function (error) {
		console.log(error);
	});
}


// Calculate the cost for the induction appointment based on 30 minute time slots
function inductionCost() {

	// rate is £60 per 30 minutes
	// const rate = 60;
	
	// Get time from select value
	// const time = $(this).val();

	// Calculate how many 30 minute slots are required and multiply by rate 
	const cost = $(this).val();

	// Get the human friendly text
	const text = $(this).find('option:selected').text();

	// Update table with data
	// Check if they selecte dover 2 hours (POA)
	if (cost === 'POA') {
		// Update text
		$el.inductionTime.text(text);
		$el.inductionTimeInput.val(text);
		// Update cost
		$el.inductionCost.text('POA');
		$el.inductionCostInput.val('POA');
	} else {
		// Update text
		$el.inductionTime.text(text);
		$el.inductionTimeInput.val(text);
		// Update cost
		$el.inductionCost.text(cost);
		$el.inductionCostInput.val(cost);
	}

	// Only show this additional row if more then 20 minute srequired
	if (text !== 'Less than 20 minutes') {
		$el.inductionAdditional.show();
	} else {
		$el.inductionAdditional.hide();
	}
}


// Smooth scrolling to target
function scrollToSections(section, negativeOffset = 100) {
	const scrollOffset = section.offset().top - negativeOffset;
	setTimeout(() => {
		TweenMax.to(window, 1.1, {
			scrollTo: {
				y: scrollOffset,
				autoKill: true, // allows user to kill scroll action smoothly
			},
			ease: Expo.easeInOut,
		});
	}, 400);
}


// Submit form data to Freeform via ajax post
function submitForm() {

	// Assign form to var
	const form = $el.form;
	// Validate form
	form.parsley({
		excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], input:hidden :hidden'
	}).validate();

	// If form is valid run ajax post
	if (form.parsley().isValid()) {

		// enable disbaled form fields so they get serialzed
		$el.boilerHolder.find('input, select').prop('disabled', false);

		// Hide the form
		$el.form.hide();

		// Show the loader
		$el.loader.show();

		// Scroll to page top
		scrollToSections($el.holder, 50);
		
		$.ajax({
			type: 'post',
			dataType: 'json',
			contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
			data: form.serialize(),
			cache: false,
		})
		.done(function(response) {
			if (response.success) {
				console.log('success');
				console.log(response);
				
				// Hide the loader
				$el.loader.hide();
				
				// Show the message
				$el.successMessage.show();
			} else {
				console.log('error');
				console.log(response);
				
				// Hide the loader
				$el.loader.hide();
				
				// Show the message
				$el.errorMessage.show();
			}
		})
		.fail(function(response) {
			console.log('fail');
			console.log(response);
			
			// Hide the loader
			$el.loader.hide();
			
			// Show the message
			$el.errorMessage.show();
		});

	} else {
		// Add something here
	}
	
	return false;		
}

